import { createCreateActionType, createCreateFetchingKey } from "@multiweb/reactUtils";

/**
 * Jméno modulu i18n. Slouží pro jednoznačnou identifikaci modulu.
 */
export const NAME = "i18n";

/**
 * Obsahuje hodnotu, která se použije místo lokalizovaného textu, pokud je lokalizační klíč načtený, ale neobsahuje žádnou hodnotu.
 */
export const UNKNOWN_KEY_TEXT = "?¿?¿?¿";

/**
 * Pomocná funkce pro vytvoření typu akce
 * @param actionType Typ akce
 */
const createActionType = createCreateActionType(NAME);

/** Konstanty typů akcí */
export const LOAD_LOCALIZATION_KEYS = createActionType("LOAD_LOCALIZATION_KEYS");
export const LOCALIZATION_KEYS_LOADED = createActionType("LOCALIZATION_KEYS_LOADED");
export const SET_LOCALE_CODE = createActionType("SET_LOCALE_CODE");
export const SET_SUPPORTED_LANGUAGES = createActionType("SET_SUPPORTED_LANGUAGES");
export const CONCAT_LOCALIZATION_ITEMS = createActionType("CONCAT_LOCALIZATION_ITEMS");
export const CLEAR_LOCALIZATION_ITEMS = createActionType("CLEAR_LOCALIZATION_ITEMS");

/** Konstanty pro porovnávací funkci */
export const COMPARE_EQUAL = 0;
export const COMPARE_REFERENCE_FIRST = -1;
export const COMPARE_REFERENCE_SECOND = 1;

/**
 * Doba čekání v ms, po kterou se seskupují akce požadující načtení lokalizací.
 * Hodnota je určena náhodně a je možné ji upravit po otestování v reálném použití.
 */
export const BATCHING_DELAY = 100;

const createFetchingKey = createCreateFetchingKey(NAME);

/**
 * Klíč pro identifikaci seskupeného načítání lokalizačních klíčů.
 */
export const BATCHING_FETCH_KEY = createFetchingKey("BATCHING_FETCH_KEY");

/**
 * Klíč pro identifikaci načítání lokalizačních klíčů po změně jazyka.
 */
export const RELOAD_FETCH_KEY = createFetchingKey("RELOAD_FETCH_KEY");

/**
 * Výchozí klíč pro fetching modul pro načítání lokalizací pomocí {@link LocalizationLoader} a {@link loadLocalizationIfNeeded}.
 */
export const DEFAULT_FETCHING_KEY = "LOCALIZATION_LOADER";
